import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  wrap: function wrap() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      vertical-align: middle;\n    "])));
  },
  input: function input() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      height: 0;\n      opacity: 0;\n      position: absolute;\n      width: 0;\n    "])));
  },
  label: function label() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      vertical-align: middle;\n      display: inline-block;\n    "])));
  },
  labelSmall: function labelSmall(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.switcherLabelGapSmall, t.switcherLabelFontSizeSmall, t.switcherLabelLineHeightSmall);
  },
  labelMedium: function labelMedium(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.switcherLabelGapMedium, t.switcherLabelFontSizeMedium, t.switcherLabelLineHeightMedium);
  },
  labelLarge: function labelLarge(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.switcherLabelGapLarge, t.switcherLabelFontSizeLarge, t.switcherLabelLineHeightLarge);
  },
  error: function error(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      border-radius: 2px;\n      box-shadow: 0 0 0 ", " ", ";\n    "])), t.switcherOutlineWidth, t.borderColorError);
  }
});